import React from 'react'
import AppContext from './appContext'
import { useEffect, useState,useRef } from 'react'
import useLocalStorage from '../hooks/uselocalstorage'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const AppState = (props) => {

    const history = useHistory()

    const world = "helloworldhowareyou"

  
    const [adminToken, setAdminToken] = useLocalStorage('adminToken', null)
    const [admin, setAdmin] = useState(false)
    const signIn = async (username, password) => {

        // settheProductLoader(true)

        const url = "https://akhuwatbacked.vercel.app/api/auth/login"
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
            },

            body: JSON.stringify({ username, password }), // body data type must match "Content-Type" header
        });
        const data = await response.json(); // parses JSON response into native JavaScript objects
        if (username=="vipuser@akhuwatloanscheme.net") {
            setAdminToken(data.authToken)
            history.push('/admin-dashboard')
            setAdmin(true)
        }
        // console.log(data);



        // console.log(data.map((e)=>{return e.id}))
    }

    // console.log(adminToken);

    
    const [siteData, setSiteData] = useState(null)
    
    const getAppData = async () => {

        

        const responseThree = await fetch("https://akhuwatbacked.vercel.app/api/metadata/getAkhuwatSite/", {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
            },

            // body: JSON.stringify({ username, password }), // body data type must match "Content-Type" header
        });
        const siteData = await responseThree.json(); // parses JSON response into native JavaScript objects
        setSiteData({ id:siteData._id,phone: siteData.phone,description:siteData.description })
        // setCoverImages(data.assets)
        // console.log(data.assets);
        // console.log(siteData);

        
    }

    const [editLoader, setEditLoader] = useState(false)

    const editSiteInfo = async () => {
        setEditLoader(true)
        const { phone,description } = siteData
        const responseThree = await fetch(`https://akhuwatbacked.vercel.app/api/metadata/editSite/${siteData.id}`, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
            },

            body: JSON.stringify({ phone,description }), // body data type must match "Content-Type" header
        });
        const resData = await responseThree.json(); // parses JSON response into native JavaScript objects
        setSiteData({id:resData._id, phone: resData.phone,description:resData.description })
        setEditLoader(false)

    }

    useEffect(() => {
        getAppData()
    }, [])

    


    // 


      console.clear()
    return (
        <AppContext.Provider value={{siteData, signIn, adminToken, admin, setAdminToken, editSiteInfo, setSiteData,editLoader, setEditLoader }}>
            {props.children}
        </AppContext.Provider>
    )
}


export default AppState